import { fireLinkTag } from './tagManager';

export function tagGwpSwapDrawerOpened() {
  fireLinkTag({
    event_name: 'pdp gwp modal open',
    link_name: 'pdp gwp modal open',
  });
}

export function tagGwpUpdateClicked() {
  fireLinkTag({
    event_name: 'pdp gwp modal update swap item',
    link_name: 'pdp gwp modal update swap item',
  });
}

export function tagUpdateAnytimeLinkClicked() {
  fireLinkTag({
    event_name: 'pdp gwp modal update anytime in bag',
    link_name: 'pdp gwp modal update anytime in bag',
  });
}

export function tagViewProductDetailsClicked() {
  fireLinkTag({
    event_name: 'pdp gwp modal view full product details',
    link_name: 'pdp gwp modal view full product details',
  });
}
